import React from 'react';

const PrivacyPolicy = () => (
  <div style={{ padding: '2rem' }}>
    <h2>Privacy Policy</h2>
    <p>We value your privacy. This policy explains how we collect, use, and protect your personal data.</p>
    <p>Information such as your name, email, and payment details are stored securely and not shared with third parties without your consent.</p>
    <p>By using our services, you agree to the terms of this Privacy Policy.</p>
  </div>
);

export default PrivacyPolicy;
